<template>
  <div class="mb-3">
    <h5 class="mb-3" v-if="product.name">{{product.name}}<span v-if="product.category"> ({{product.category.name}}) - {{product.id}}</span></h5>
    <b-row>
      <b-col>
        <p v-show="product.id && product.skus.length === 0" class="alert alert-warning"><i class="fa fa-exclamation-triangle"></i> Este producto no contiene SKUs creados</p>
      </b-col>
    </b-row>
    <div>
      <b-alert :show="errorText !== ''" fade dismissible variant="danger">
        <h4 class="alert-heading">Se ha producido un error!</h4>
        <hr>
        <p v-html="errorText">{{errorText}}</p>
      </b-alert>
      <b-alert :show="successText !== ''" variant="success" dismissible>
        {{successText}}
      </b-alert>
    </div>

    <b-modal 
      header-bg-variant="primary" 
      size="lg" 
      ref="confirmationModal" 
      id="confirmationModal" 
      centered 
      :title="confirmationModalData.confirmationModalTitle"
      @ok="handleSaveModal"
      :hide-footer="currentState == 'Aprobar' ? !showModalFooter: false"
      cancel-title="Cancelar">
      <span v-if="currentState != 'Aprobar'">
        {{confirmationModalData.confirmationModalText}}
      </span>
      <FormActiveSku 
        v-if="currentState == 'Aprobar' && isAdmin"
        :products="this.variantsSelected.length" 
        @showbtns="isvalidForm" 
      />
    </b-modal>

    <b-modal
      header-bg-variant="primary"
      size="lg"
      ref="creationModal"
      id="creationModal"
      centered
      :title="!this.product.id? `Procesar alta de Producto: ${this.product.name}` : `Procesar modificacion de Producto: ${this.product.name}`"
      @ok="_createProduct"
      cancel-title="Cancelar"
    >
      <span>
        ¿Desea continuar?
      </span>
    </b-modal>

    <b-tabs v-model="tabIndex">
      <moon-loader class="mt-3" :loading="loading" color="#000" size="30px"></moon-loader>
      <b-tab title="Datos del producto" active>
        <b-row class="mt-4">
          <div class="w-100 text-right px-3 mb-3" :class="!isAdmin ? 'mr-3' : ''">
            <router-link v-if="false" :to="{ path: '/incidents/list', query: { product: product.id }}">{{$t('Crear incidencia')}}</router-link>
            <button type="button" class="btn btn-outline-primary" @click.stop="scrollToIncidence()">Incidencias</button>
          </div>
          <b-col>
            <span
                v-if="disableDeleteBtnProdSeller"
                class="float-right mr-3 text-primary"
                v-b-tooltip.hover
                title="No puedes eliminar el producto porque uno de sus SKU está activo, si quieres eliminarlo debes contactarte con el administrador del sitio">
              <i class="fas fa-question-circle"></i>
            </span>
            <button 
              :disabled="!product.id || loading || disableDeleteBtnProdSeller"
              type="button" 
              class="btn btn-primary float-right mr-3"  
              @click="deleteProduct">
              <i class="far fa-trash-alt"></i> Eliminar Producto
            </button>
            <button v-if="!isAdmin" :disabled="!product.id || loading" type="button" class="btn btn-primary float-right mr-2"  @click="createSku">
              <i class="fa fa-plus"/> Crear Variante
            </button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card v-show="!loading" header="Datos generales" class="my-3" header-bg-variant="success">
              <b-col>
                <b-form-group
                  id="idInput"
                  :label-cols="2"
                  breakpoint="md"
                  label="ID"
                  label-for="idInput">
                  <b-form-input
                    id="idInṕut"
                    v-model="product.id"
                    :disabled="true">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
                  <b-form-group
                    id="nombreInput"
                    :label-cols="2"
                    breakpoint="md"
                    label="Nombre"
                    description="Máximo 100 caracteres"
                    :invalid-feedback="!isValidText(product.name, true) ? 'El nombre no es válido' : ''"
                    :state="isValidText(product.name, true)"
                    label-for="nombreFormatterHelp">
                    <b-form-input
                      id="nombreFormatterHelp"
                      v-model="product.name"
                      :disabled="editionDisabled"
                      maxlength="100">
                    </b-form-input>
                  </b-form-group>
                </b-col>
            <b-col>
                <b-form-group
                    id="categoriaInput"
                    :label-cols="2"
                    breakpoint="md"
                    label="Categoría"
                    :invalid-feedback="!Boolean(product.category) ? 'Seleccione una categoria' : ''"
                    :state="Boolean(product.category)"
                    label-for="categoryFormatterHelp">
                    <category-tree
                      :editable="!editionDisabled"
                      id='categoryFormatterHelp'
                      :categorySelected="product.category"
                      @onCategorySelected="selectCategory">
                    </category-tree>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="marcaInput"
                    :label-cols="2"
                    breakpoint="md"
                    label="Marca"
                    :invalid-feedback="productBrand.length == 0 ? 'Seleccione una marca' : ''"
                    :state="productBrand.length > 0"
                    label-for="marcaFormatterHelp">
                    <autocomplete
                      :v-if="product.brand"
                      id="inputBrand"
                      class="input_class optional"
                      name="inputBrand"
                      :maxElements="1"
                      placeholder="Ingrese una marca..."
                      :provider="getSearchBrands"
                      :disabled="editionDisabled"
                      v-model="productBrand">
                    </autocomplete>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="textLinkInput"
                    :label-cols="2"
                    breakpoint="md"
                    label="Descripción"
                    :invalid-feedback="!isValidTextArea(product.description, true) ? 'La descripción no es un texto / html válido' : ''"
                    :state="isValidTextArea(product.description, true)"
                    label-for="textlinkFormatterHelp">
                    <vue-editor :editorToolbar="customToolbar" :disabled="editionDisabled" name="Description" v-model="product.description" />
                  </b-form-group>
                </b-col>
            </b-card>
          </b-col>
          <b-col>
            <b-card v-show="!loading" header="Especificaciones" class="my-3" header-bg-variant="success">
              <product-attributes :disabled="isAdmin" :mergedInfo="specificationsComputedMap"></product-attributes>
            </b-card>
          </b-col>
          <!-- Incidence table -->
          <b-col md="12">
            <b-card class="controversy-card" title="Incidencias" v-if="product.id" ref="IncidenceContainer">
              <button @click.stop="createIncidence()" type="button" class="add-controversy btn btn-primary float-right mr-2"><i class="fa fa-plus mr-2"></i>{{$t('Crear incidencia')}}</button>
              <b-col>
                <incidents-table
                  ref="indicentsTable"
                  :filters="incidenceFilters"
                  :showIncidenceDetail="true"
                >
                </incidents-table>
              </b-col>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="SKUs">
        <b-row class="row m-0 mb-2">
          <b-col class="p-0">
            <button v-if="!isAdmin" :disabled="!product.id || loading" type="button" class="btn btn-primary float-right ml-2"  @click="createSku">
              <i class="fa fa-plus"/> Crear Variante
            </button>
            <button type="button" class="btn btn-primary float-right"  @click.stop="showFilters = !showFilters">
              <i class="fa" :class="{'fa-times': showFilters, 'fa-filter': !showFilters}" /> Filtros
            </button>
          </b-col>
        </b-row>
        <transition name="fade">
          <div class="filters p-3" v-show="showFilters">
            <b-row>
              <b-col>
                <b-form-group id="filterSku"
                  horizontal
                  :label-cols="4"
                  breakpoint="md"
                  label="SKU"
                  :invalid-feedback="!isValidInteger(filter.sku, false)? 'No es un valor válido' : ''"
                  :state="isValidInteger(filter.sku, false)"
                  label-for="skuDesdeFormatter">
                  <b-input-group>
                    <b-form-input id="filterSkuInput" v-model="filter.sku"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="filterUpc"
                  horizontal
                  :label-cols="4"
                  breakpoint="md"
                  label="UPC"
                  :invalid-feedback="!isValidInteger(filter.upc, false)? 'No es un valor válido' : ''"
                  :state="isValidInteger(filter.upc, false)"
                  label-for="skuDesdeFormatter">
                  <b-input-group>
                    <b-form-input id="filterUpcInput" v-model="filter.upc"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="stateInput"
                  horizontal
                  :label-cols="4"
                  breakpoint="md"
                  label="Estado"
                  label-for="stateFormatter">
                  <b-form-select id="stateFormatter" :options="estados" v-model="filter.estado">
                    <option slot="first" :value="null">Todos</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-input-group-button class="float-right mt-3 mr-3">
                  <b-button :disabled="loading" :block="true" variant="primary" @click.stop="cleanFilters" >Limpiar</b-button>
                </b-input-group-button>
              </b-col>
            </b-row>
          </div>
        </transition>

        <b-row>
          <b-col md="12">
            <button type="button" @click="showActionModal('Aprobar')" v-show="isAdmin" :disabled="variantsSelected.length === 0" class="btn btn-primary float-right ml-2">Activar</button>
            <button type="button" @click="showActionModal('Rechazar')" v-show="isAdmin" :disabled="variantsSelected.length === 0" class="btn btn-primary float-right ml-2">Rechazar</button>
            <button type="button" @click="showActionModal('Eliminar')" :disabled="variantsSelected.length === 0 || disableDeleteButtonAdmin" class="btn btn-primary float-right ml-2">Eliminar</button>
          </b-col>
          <b-col class="col-md-auto">
            <b-pagination :total-rows="variantTotalRows" :per-page="variantPerPage" v-model="variantCurrentPage" class="mb-3" />
          </b-col>
          <b-col class="col-md-auto">
            <b-form-group
              id="perPage"
              horizontal
              label="Mostrar por página">
              <b-form-select :options="variantPageOptions" v-model="variantPerPage" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="product.skus.length > 0">
          <b-col md="3" class="my-2">
            <b-form-select
              class="action-form-select"
              id="selectProductGroup"
              :options="productGroupSelection.options"
              required
              v-model="productGroupSelection.current"
              @click.native.stop
              @change="productGroupSelectionHandler">
            </b-form-select>
          </b-col>
        </b-row>
        <b-table id="mainTable"
          ref="variantTable"
          show-empty
          hover
          :current-page="variantCurrentPage"
          :per-page="variantPerPage"
          :items="variantItemProvider"
          :fields="fieldsVariant"
          responsive=true
          @row-dblclicked="variantDbClicked"
          stacked="xl"
          empty-text="No hay variantes para mostrar"
          empty-filtered-text="No hay variantes para mostrar">
          <template slot="selected" slot-scope="row">
            <b-form-checkbox 
              class="ml-4"
              :class="{ 'disabled-checkbox': isCheckboxDisabled(row.item) }"
              :disabled="isCheckboxDisabled(row.item)"
              @click.native.stop
              @change="handleRowCheckbox(row.item)"
              :value="row.item.id"
              v-model="variantsSelected">
            </b-form-checkbox>
          </template>
          <template slot="price" slot-scope="row">
            {{currency}} {{row.item.price.listPrice}}<br>
            <span v-b-tooltip.hover title="Precio con descuento" class="discount">({{currency}} {{row.item.price.price}})</span><br>
            {{row.item.price.priceValidUntil}}
          </template>
            <template slot="inventory" slot-scope="row">
              <div class="inventoryContainer" v-b-tooltip.hover title="La cantidad entre parentesis es stock reservado">
                <span class="inventoryTotal">{{row.item.inventory.totalQuantity}}</span>
                <span class="inventoryReserved">({{row.item.inventory.reservedQuantity ? row.item.inventory.reservedQuantity : 0}})</span>
              </div>
          </template>
          <template slot="status"  slot-scope="data">
            <b v-if="data.value === 'APPROVED'" class="text-success">
              {{estados.find(p => p.value === data.value).text}}
            </b>
            <b v-if="data.value === 'REJECTED'" class="text-danger">
              {{estados.find(p => p.value === data.value).text}}
            </b>
            <b v-if="data.value === 'PENDING_APPROVAL'" class="text-warning">
              {{estados.find(p => p.value === data.value).text}}
            </b>
          </template>
          <template slot="actions"  slot-scope="row">
            <span class="mr-2" v-show="!isAdmin && row.item.status !== 'APPROVED'" @click="deleteVariant(row.item)"><i class="fas fa-trash cursor-pointer"></i></span>
            <b-button class="primary" size="sm" variant="link" @click.stop="row.toggleDetails">
              <span v-show="!row.detailsShowing"><i class="fa fa-plus"></i></span>
              <span v-show="row.detailsShowing"><i class="fa fa-minus"></i></span>
                {{$t('Incidencias')}}
            </b-button>
          </template>
          <template slot="row-details" slot-scope="row">
            <div>
              <div class="row position-relative"><button @click.stop="createSkuIncidence(row.item.id)" type="button" class="add-controversy-sku btn btn-primary mr-1 mb-3 float-right"><i class="fa fa-plus mr-2"></i>{{$t('Crear incidencia')}}</button></div>
              <incidents-table
                :filters="{
                  fromDate: null,
                  toDate: null,
                  incidenceType: 'SKU',
                  accountName: null,
                  priority: null,
                  status: null,
                  text: row.item.id
                }"
                :showIncidenceDetail="true"
              >
              </incidents-table>
            </div>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
    <b-row v-if="!isAdmin && tabIndex === 0" class="mt-4">
      <b-col>
        <div class="d-flex justify-content-end">
          <b-button :disabled="loading" class="mr-4" @click="handleMount">Cancelar</b-button>
          <b-button :disabled="saveButtonDisabled || loading" @click="handleSave">Guardar</b-button>
        </div>
      </b-col>
    </b-row>
    <sku-modal @needReload="reloadInformation" ref="skuModal"></sku-modal>
  </div>
</template>

<script>

// Components
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import CategoryTree from './CategoryTree'
import ProductAttributes from './ProductAttributes'
import appConfig from '@/config/applicationConfig.js'
import SkuModal from './SkuModal'
import incidentsTable from '@/components/incidents/IncidentsTable'
import autocomplete from '@/components/common/vue-autocomplete'
import { VueEditor } from 'vue2-editor'
import FormActiveSku from '@/components/common/FormActiveSku'

// Mixims
import { ProductServiceMixim, PRODUCT_STATES } from '@/mixims/ProductServiceMixim'
import {ValidationsMixim} from '@/mixims/ValidationsMixim.js'

export default {
  name: 'productDetail',
  mixins: [ProductServiceMixim, ValidationsMixim],
  components: {
    MoonLoader,
    CategoryTree,
    ProductAttributes,
    SkuModal,
    autocomplete,
    VueEditor,
    FormActiveSku,
    incidentsTable
  },
  props: ['productId'],
  watch: {
    '$route.params.productId': {
      handler (newProductId, oldProductId) {
        if (newProductId && newProductId !== oldProductId) {
          // Limpiar estado
          this.successText = ''
          this.errorText = ''
          this.variantsSelected = []
          this.selectedItems = []
          this.cleanFilters()
          // Verificar si viene un SKU
          if (this.$route.query.sku) {
            this.tabIndex = 1
            this.showFilters = true
            this.filter.sku = this.$route.query.sku
          }
          // Recargar producto
          this.handleMount()
        }
      },
      immediate: false
    },
    '$route.query.sku': {
      handler (newSku, oldSku) {
        if (newSku && newSku !== oldSku) {
          this.tabIndex = 1
          this.showFilters = true
          this.filter.sku = newSku
        }
      },
      immediate: false
    }
  },
  data () {
    return {
      productGroupSelection: {
        options: [
          { text: 'Seleccione una opción', value: null, disabled: true },
          { text: 'Ninguno', value: 'Ninguno' },
          { text: 'Todos', value: 'Todos' }
        ],
        current: null
      },
      currentState: '',
      activateProductData: [],
      showModalFooter: false,
      showFilters: false,
      loading: false,
      variantGroupAction: null,
      saveResult: {},
      isAdmin: this.$store.getters.isAdmin,
      product: {
        id: null,
        skus: [],
        category: null,
        brand: null,
        productSpecifications: []
      },
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline'],
        [
          { list: 'ordered' },
          { list: 'bullet' }
        ],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['link'],
        [{ color: [] }, { background: [] }],
        [{ header: 1 }, { header: 2 }],
        ['clean']
      ],
      productBrand: [],
      tabIndex: 0,
      specifications: [],
      selectedItems: [],
      successText: '',
      errorText: '',
      confirmationModalData: {
        confirmationModalOkHandler: '',
        confirmationModalCancelHandler: '',
        confirmationModalText: '',
        confirmationModalTitle: ''
      },
      locale: appConfig.LOCALE,
      currency: appConfig.CURRENCY,
      variantCurrentPage: 1,
      variantPerPage: 10,
      variantTotalRows: 0,
      variantPageOptions: [ 10, 15, 25, 50, 100 ],
      // brandOptions: this.$store.getters.brands.map(b => { return { text: b.name, value: b } }),
      variantsSelected: [],
      filter: {
        sku: null,
        upc: null,
        estado: null
      },
      fieldsVariant: [
        { key: 'selected', label: 'Selección' },
        { key: 'upc', label: 'UPC', 'class': 'text-left' },
        { key: 'id', label: 'SKU', 'class': 'text-left' },
        { key: 'skuName', label: 'Nombre', 'class': 'text-left' },
        { key: 'refId', label: 'Identificador', 'class': 'text-left' },
        { key: 'price', label: 'Precio con descuento', class: 'priceCol' },
        { key: 'inventory', label: 'Inventario', 'class': 'text-left' },
        { key: 'status', label: 'Estado', 'class': 'text-left' },
        { key: 'actions', label: 'Acciones', 'class': 'text-right' }
      ],
      estados: PRODUCT_STATES,
      incidenceFilters: {
        fromDate: null,
        toDate: null,
        incidenceType: null,
        accountName: null,
        priority: null,
        status: null
      }
    }
  },
  methods: {
    isvalidForm (stateForm) {
      this.activateProductData = stateForm.data
      this.showModalFooter = stateForm.state
    },
    cleanFilters () {
      this.filter.sku = null
      this.filter.upc = null
      this.filter.estado = null
    },
    productGroupSelectionHandler (selectionType) {
      this.variantsSelected.splice(0, this.variantsSelected.length)
      switch (selectionType) {
        case 'Ninguno':
          break
        case 'Todos':
          this.product.skus.forEach(sku => {
            if (!this.isCheckboxDisabled(sku)) {
              this.variantsSelected.push(sku.id)
              this.selectedItems.push(sku)
            }
          })
          break
        default:
          break
      }
    },
    showActionModal (action) {
      this.currentState = action
      this.confirmationModalData.confirmationModalTitle = `Confirmar ${this.currentState}`
      this.confirmationModalData.confirmationModalText = this.variantsSelected.length > 1 ? `Se procedera a ${this.currentState} las ${this.variantsSelected.length} variantes` : `Se procedera a ${this.currentState} la variante`
      this.$refs.confirmationModal.show()
    },
    handleSaveModal () {
      let actionFunction = null
      let errorVerv = ''
      this.successText = ''
      this.errorText = ''
      let _acceptances = null
      if (this.currentState === 'EliminarProducto') {
        this.loading = true
        this.errorText = ''
        this.successText = ''
        this.deleteProducts([this.product.id], false).then(
          () => {
            this.loading = false
            this.successText = 'El producto fue eliminado con éxito'
            this.$refs.confirmationModal.hide()
            this.product = {
              id: null,
              skus: [],
              productSpecifications: []
            }
            this.currentState = ''
          },
          (error) => {
            this.loading = false
            if (error.status === 409) {
              this.errorText = 'Algunos productos/skus no se lograron eliminar. Por favor verifique el estado de los skus.'
              this.reloadInformation()
            } else {
              this.errorText = error.body.message || `Error eliminando los productos`
            }
            this.currentState = ''
          }
        )
      } else {
        switch (this.currentState) {
          case 'Aprobar':
            actionFunction = this.activateProducts
            _acceptances = this.activateProductData
            errorVerv = 'aprobando'
            break
          case 'Rechazar':
            actionFunction = this.rejectProducts
            errorVerv = 'rechazando'
            break
          case 'Eliminar':
            actionFunction = this.deleteProducts
            errorVerv = 'eliminando'
            break
        }
        this.confirmationModalData.confirmationModalTitle = `Confirmar ${this.currentState}`
        this.confirmationModalData.confirmationModalText = this.variantsSelected.length > 1 ? `Se procedera a ${this.currentState} las ${this.variantsSelected.length} variantes` : `Se procedera a ${this.currentState} la variante`
        this.loading = ''
        actionFunction(this.variantsSelected, true, _acceptances).then(
          () => {
            this.variantsSelected.splice(0, this.variantsSelected.length)
            this.successText = 'Se completó la tarea con éxito'
            this.loading = false
            this.reloadInformation()
          },
          (error) => {
            if (error.status === 409) {
              this.errorText = `Algunos productos/skus no se lograron ${this.currentState.toLowerCase()}. Por favor verifique el estado de los skus.`
            } else {
              this.errorText = error.body.message || `Error ${errorVerv} los productos`
            }
            this.loading = false
            this.reloadInformation()
          }
        )
      }
    },
    handleRowCheckbox (sku) {
      const index = this.selectedItems.findIndex(selectedItem => selectedItem.id === sku.id)
      if (index === -1) this.selectedItems.push(sku)
      else this.selectedItems.splice(index, 1)
    },
    isCheckboxDisabled (item) {
      if (!this.isAdmin) return item.status === 'APPROVED'
    },
    deleteVariant (variant) {
      this.confirmationModalData.confirmationModalTitle = `Eliminar SKU`
      this.confirmationModalData.confirmationModalText = `Se procedera a eliminar la variante ${variant.skuName}`
      this.confirmationModalData.confirmationModalOkHandler = () => {
        this.loading = true
        this.errorText = ''
        this.successText = ''
        this.deleteProducts([variant.id], true).then(
          () => {
            this.$refs.confirmationModal.hide()
            this.successText = 'La variante fue eliminada con éxito'
            this.handleMount()
          },
          (error) => {
            this.loading = false
            this.errorText = error.body.message || 'Error eliminando la variante'
          }
        )
      }
      this.$refs.confirmationModal.show()
    },
    deleteProduct () {
      this.currentState = 'EliminarProducto'
      this.confirmationModalData.confirmationModalTitle = `Eliminar Producto`
      this.confirmationModalData.confirmationModalText = `Se procedera a eliminar el producto ${this.product.id}`
      this.$refs.confirmationModal.show()
    },
    reloadInformation (response) {
      if (response) {
        if (response.status) {
          this.successText = response.text
          this.currentState = ''
        } else {
          this.currentState = ''
          this.errorText = response.text
        }
      }
      this.handleMount()
      this.tabIndex = 1
    },
    createSku () {
      this.errorText = ''
      this.successText = ''
      this.$refs.skuModal.show(
        {
          id: null,
          price: {},
          dimension: {},
          images: [],
          inventory: {},
          commercialCondition: {},
          skuSpecifications: []
        },
        this.product
      )
    },
    variantDbClicked (item) {
      this.errorText = ''
      this.successText = ''
      this.$refs.skuModal.show(JSON.parse(JSON.stringify(item)), this.product)
    },
    _pendingProps () {
      return this.specificationsComputedMap.some(
        (prop) => {
          if (prop.value.isRequired) {
            return Object.keys(prop.value.specificationFieldValues[0]).length === 0 || !prop.value.specificationFieldValues[0].value
          }
        }
      )
    },
    selectCategory (category) {
      this.loading = true
      this.errorText = ''
      this.product.category = category
      return this.getProductAtributes(category.id).then(
        (res) => {
          this.product.productSpecifications.splice(0, this.product.productSpecifications.length)
          this.specifications = res.body
          this.loading = false
        },
        (error) => {
          this.loading = false
          this.errorText = error.body.message || 'Error obteniendo los atributos del producto'
        }
      )
    },
    handleMount () {
      if (this.productId) {
        this.loading = true
        return this.getProduct().then(
          (res) => {
            this.product = res.body
            this.incidenceFilters.text = this.product.id
            if (this.product.productSpecifications === null) {
              this.product.productSpecifications = []
            }
            this.variantTotalRows = this.product.skus.length

            if (this.product.brand.name) {
              this.productBrand.push(this.product.brand)
            }
            this.$refs.variantTable.refresh()
            return this.getProductAtributes(this.product.category.id).then(
              (specifications) => {
                this.loading = false
                this.specifications = specifications.body
              },
              (error) => {
                this.loading = false
                this.errorText = error.body.message || 'Error obteniendo las especificaciones del producto'
              }
            )
          },
          (error) => {
            this.loading = false
            this.errorText = error.body.message || 'Error obteniendo el producto'
          }
        )
      }
    },
    handleSave (evt) {
      window.scrollTo(0, 0)
      this.$refs.creationModal.show()
    },
    _createProduct () {
      this.errorText = ''
      this.successText = ''

      if (this.product.productSpecifications) {
        this.product.productSpecifications.forEach(spec => {
          if (spec.specificationFieldValues && spec.specificationFieldValues.length > 0) {
            const valorActual = spec.specificationFieldValues[0]
            if (valorActual === false || (valorActual !== null && typeof valorActual !== 'object')) {
              spec.specificationFieldValues[0] = {
                fieldValueId: null,
                value: null,
                isActive: null
              }
            }
          }
        })
      }
      this.loading = true
      this.product.brand = this.productBrand[0]
      if (this.product.id) {
        return this.updateProduct(this.product).then(
          (res) => {
            this.successText = 'El producto fue actualizado con exito'
            this.loading = false
          },
          (error) => {
            this.errorText = error.body.message || 'Error actualizando el producto'
            this.loading = false
          }
        )
      }

      return this.createProduct(this.product).then(
        (res) => {
          this.product.id = res.id
          this.successText = 'El producto fue creado con exito'
          this.loading = false
          this.createSku()
        },
        (error) => {
          this.errorText = error.body.message || 'Error creando el producto'
          this.loading = false
        }
      )
    },
    createIncidence () {
      this.$router.push({path: '/incidents/list', query: { product: this.productId }})
    },
    createSkuIncidence (sku) {
      this.$router.push({path: '/incidents/list', query: { sku: sku }})
    },
    scrollToIncidence () {
      const el = this.$refs.IncidenceContainer
      if (el) {
        el.scrollIntoView()
      }
    }
  },
  mounted () {
    if (this.$route.query.sku) {
      this.tabIndex = 1
      this.showFilters = true
      this.filter.sku = this.$route.query.sku
    }
    this.handleMount()
  },
  computed: {
    disableFilterButton () {
      if (!this.isValidInteger(this.filter.sku, false) || !this.isValidInteger(this.filter.upc, false)) {
        return true
      }
    },
    disableDeleteButtonAdmin () {
      if (this.isAdmin && this.selectedItems.length > 0) {
        return this.selectedItems.some(sku => sku.status === 'PENDING_APPROVAL' || sku.status === 'REJECTED')
      } else {
        return false
      }
    },
    disableDeleteBtnProdSeller () {
      if (!this.isAdmin) {
        return this.product.skus.some(sku => sku.status === 'APPROVED')
      }
      return false
    },
    variantItemProvider () {
      let items = this.product.skus.filter((sku) => {
        let value = true
        if (this.filter.sku && value) {
          if (!String(sku.id).includes(this.filter.sku)) {
            value = false
          }
        }
        if (this.filter.upc && value) {
          if (!String(sku.upc).includes(this.filter.upc)) {
            value = false
          }
        }
        if (this.filter.estado && value) {
          if (sku.status !== this.filter.estado) {
            value = false
          }
        }
        return value
      })
      let start = (this.variantCurrentPage - 1) * this.variantPerPage
      let end = this.variantPerPage * this.variantCurrentPage
      return items.slice(start, end)
    },
    editionDisabled: function () {
      if (this.isAdmin) {
        return true
      }

      return this.product.skus.some((sku) => sku.status === 'APPROVED')
    },
    specificationsComputedMap: function () {
      let attributes = this.product.productSpecifications
      return this.specifications.map(spec => {
        let newAttr
        let foundAttr = attributes.find(attr => attr && attr.name === spec.name)
        if (!foundAttr) {
          newAttr = {
            ...spec,
            specificationFieldValues: [{}]
          }
          this.product.productSpecifications.push(newAttr)
        }
        return {
          spec,
          value: foundAttr !== undefined ? foundAttr : newAttr}
      })
    },
    saveButtonDisabled: function () {
      if (!this.isValidText(this.product.name, true) || this.isEmptyData(this.product.category) || this.isEmptyData(this.product.description) || !this.productBrand.length > 0) {
        return true
      }
      if (this._pendingProps()) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
  .filters {
    border: 1px solid #e3e8ec;
    margin: 10px 0 15px;
  }
  .priceCol {
    .discount {
     font-size: 12px;
     font-weight: bolder;
    }

  }

  .inventoryContainer {
    display: inline-block;

    .inventoryTotal {
      font-weight: bolder;
      font-size: 16px;
    }

    .inventoryReserved {
      color: #777;
    }
  }

  .add-controversy {
   position: absolute;
   top: 14px;
   right: 12px;
  }

  .add-controversy-sku {
   position: absolute;
   top: 0;
   right: 12px;
  }

  .disabled-checkbox {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .cursor-pointer {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/catalog/ProductDetail.vue